import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import NotFound from './views/not-found'
import PrivacyPolicy from './views/privacy'
import Terms from './views/terms'
import Help from './views/help'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={PrivacyPolicy} exact path="/privacy-policy" />
        <Route component={Terms} exact path="/terms" />
        <Route component={Help} exact path="/help" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
